import { Link } from "react-router-dom";

const CookiesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <nav className="sticky top-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#0F2557] font-bold text-lg">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line text-base"></i>
            </div>
            Wróć na stronę główną
          </Link>
          <span className="text-xs text-gray-400">Ostatnia aktualizacja: 03.04.2026</span>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 py-14 lg:py-20">
        <header className="mb-12">
          <span className="inline-block text-[#0F2557] text-sm font-semibold tracking-wide uppercase mb-3">Dokument prawny</span>
          <h1 className="text-4xl font-bold text-[#1A1A2E] mb-4">Polityka Cookies</h1>
          <p className="text-gray-500 text-lg">Niniejsza Polityka Cookies wyjaśnia, czym są pliki cookies, jakie rodzaje stosujemy i jak możesz nimi zarządzać.</p>
        </header>

        <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 mb-10 flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-information-line text-amber-500 text-base"></i>
          </div>
          <p className="text-sm text-amber-800 leading-relaxed">
            Korzystając z naszej strony internetowej, wyrażasz zgodę na używanie plików cookies zgodnie z niniejszą Polityką Cookies. Jeśli nie zgadzasz się na używanie plików cookies, zmień ustawienia swojej przeglądarki.
          </p>
        </div>

        <div className="prose max-w-none text-gray-600 leading-relaxed space-y-10">

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">1. Czym są pliki cookies?</h2>
            <p>Pliki cookies (ciasteczka) to małe pliki tekstowe zapisywane na Twoim urządzeniu (komputerze, telefonie, tablecie) podczas odwiedzania stron internetowych. Służą do zapamiętywania preferencji użytkownika, analizy ruchu na stronie oraz personalizacji treści.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">2. Jakie cookies stosujemy?</h2>
            <div className="space-y-4">
              {[
                {
                  type: "Niezbędne (techniczne)",
                  color: "bg-green-50 border-green-200",
                  badge: "bg-green-100 text-green-700",
                  required: true,
                  desc: "Konieczne do prawidłowego działania strony. Bez nich strona nie może funkcjonować poprawnie.",
                  examples: ["Sesja użytkownika", "Preferencje językowe", "Bezpieczeństwo formularzy"],
                  retention: "Do zamknięcia przeglądarki lub do 1 roku",
                },
                {
                  type: "Analityczne",
                  color: "bg-blue-50 border-blue-200",
                  badge: "bg-blue-100 text-blue-700",
                  required: false,
                  desc: "Pomagają zrozumieć, jak użytkownicy korzystają ze strony. Dane są anonimowe i służą do poprawy jakości serwisu.",
                  examples: ["Google Analytics (_ga, _gid)", "Liczba odwiedzin", "Czas spędzony na stronie"],
                  retention: "Do 2 lat",
                },
                {
                  type: "Marketingowe",
                  color: "bg-orange-50 border-orange-200",
                  badge: "bg-orange-100 text-orange-700",
                  required: false,
                  desc: "Używane do wyświetlania spersonalizowanych reklam. Stosowane tylko za Twoją zgodą.",
                  examples: ["Facebook Pixel", "Google Ads", "Remarketing"],
                  retention: "Do 90 dni",
                },
              ].map((cookie) => (
                <div key={cookie.type} className={`rounded-xl border p-5 ${cookie.color}`}>
                  <div className="flex items-center gap-3 mb-3">
                    <h3 className="font-bold text-[#1A1A2E]">{cookie.type}</h3>
                    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${cookie.badge}`}>
                      {cookie.required ? "Zawsze aktywne" : "Opcjonalne"}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mb-3">{cookie.desc}</p>
                  <div className="flex flex-wrap gap-2 mb-2">
                    {cookie.examples.map((ex) => (
                      <span key={ex} className="text-xs bg-white/70 text-gray-600 px-2 py-1 rounded-md">{ex}</span>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500"><strong>Okres przechowywania:</strong> {cookie.retention}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">3. Cookies podmiotów trzecich</h2>
            <p className="mb-4">Na naszej stronie mogą być stosowane cookies podmiotów trzecich:</p>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-[#0F2557] text-white">
                    <th className="text-left px-4 py-3 rounded-tl-lg">Podmiot</th>
                    <th className="text-left px-4 py-3">Cel</th>
                    <th className="text-left px-4 py-3 rounded-tr-lg">Polityka prywatności</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100">
                    <td className="px-4 py-3 font-medium text-gray-700">Google Analytics</td>
                    <td className="px-4 py-3 text-gray-500">Analityka ruchu na stronie</td>
                    <td className="px-4 py-3"><a href="https://policies.google.com/privacy" target="_blank" rel="nofollow noopener noreferrer" className="text-[#0F2557] hover:underline text-xs">policies.google.com</a></td>
                  </tr>
                  <tr className="border-b border-gray-100 bg-[#F7F8FA]">
                    <td className="px-4 py-3 font-medium text-gray-700">Google Ads</td>
                    <td className="px-4 py-3 text-gray-500">Reklamy i remarketing</td>
                    <td className="px-4 py-3"><a href="https://policies.google.com/privacy" target="_blank" rel="nofollow noopener noreferrer" className="text-[#0F2557] hover:underline text-xs">policies.google.com</a></td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-medium text-gray-700">Meta (Facebook)</td>
                    <td className="px-4 py-3 text-gray-500">Facebook Pixel, reklamy</td>
                    <td className="px-4 py-3"><a href="https://www.facebook.com/privacy/policy" target="_blank" rel="nofollow noopener noreferrer" className="text-[#0F2557] hover:underline text-xs">facebook.com/privacy</a></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">4. Jak zarządzać plikami cookies?</h2>
            <p className="mb-4">Możesz kontrolować i zarządzać plikami cookies na kilka sposobów:</p>
            <div className="grid sm:grid-cols-2 gap-4">
              {[
                { icon: "ri-settings-3-line", title: "Ustawienia przeglądarki", desc: "Możesz zablokować lub usunąć cookies w ustawieniach swojej przeglądarki internetowej." },
                { icon: "ri-shield-check-line", title: "Tryb prywatny", desc: "Korzystanie z trybu prywatnego (incognito) ogranicza zapisywanie cookies po zamknięciu okna." },
                { icon: "ri-global-line", title: "Narzędzia opt-out", desc: "Google Analytics Opt-out: tools.google.com/dlpage/gaoptout" },
                { icon: "ri-delete-bin-line", title: "Usunięcie cookies", desc: "Możesz usunąć już zapisane cookies w ustawieniach przeglądarki w dowolnym momencie." },
              ].map((item) => (
                <div key={item.title} className="bg-[#F7F8FA] rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${item.icon} text-[#0F2557] text-base`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-[#1A1A2E]">{item.title}</h3>
                  </div>
                  <p className="text-xs text-gray-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
            <div className="mt-4 bg-[#F7F8FA] rounded-lg p-4">
              <p className="text-sm font-semibold text-[#1A1A2E] mb-2">Jak wyłączyć cookies w popularnych przeglądarkach:</p>
              <ul className="space-y-1">
                {[
                  { name: "Google Chrome", url: "support.google.com/chrome/answer/95647" },
                  { name: "Mozilla Firefox", url: "support.mozilla.org/pl/kb/wzmocniona-ochrona-przed-sledzeniem" },
                  { name: "Safari", url: "support.apple.com/pl-pl/guide/safari/sfri11471/mac" },
                  { name: "Microsoft Edge", url: "support.microsoft.com/pl-pl/microsoft-edge" },
                ].map((browser) => (
                  <li key={browser.name} className="text-xs text-gray-500 flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-[#0F2557]"></i>
                    <strong className="text-gray-700">{browser.name}:</strong>
                    <a href={`https://${browser.url}`} target="_blank" rel="nofollow noopener noreferrer" className="text-[#0F2557] hover:underline">{browser.url}</a>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">5. Zmiany w Polityce Cookies</h2>
            <p>Zastrzegamy sobie prawo do zmiany niniejszej Polityki Cookies. O wszelkich zmianach poinformujemy poprzez aktualizację daty na górze dokumentu. Zalecamy regularne sprawdzanie tej strony.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">6. Kontakt</h2>
            <p className="mb-3">W przypadku pytań dotyczących plików cookies skontaktuj się z nami:</p>
            <div className="bg-[#F7F8FA] rounded-lg p-5 space-y-2">
              <p className="text-sm"><strong className="text-[#1A1A2E]">E-mail:</strong> <a href="mailto:tomasz.kdp@gmail.com" className="text-[#0F2557] hover:underline">tomasz.kdp@gmail.com</a></p>
              <p className="text-sm"><strong className="text-[#1A1A2E]">Telefon:</strong> <a href="tel:+48509963499" className="text-[#0F2557] hover:underline">+48 509 963 499</a></p>
            </div>
          </section>

        </div>
      </main>

      <footer className="border-t border-gray-100 py-8 mt-10">
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400">&copy; {new Date().getFullYear()} Strony www dla firm usługowych. Wszelkie prawa zastrzeżone.</p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/polityka-prywatnosci" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Polityka prywatności</Link>
            <Link to="/rodo" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">RODO</Link>
            <Link to="/regulamin" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Regulamin</Link>
            <Link to="/polityka-cookies" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Cookies</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CookiesPage;
